"use client";

/**
 * Arranca el drainer del outbox una sola vez en cliente.
 *
 * Lo hacemos en un componente separado (no inline en layout) para que el
 * drainer importe IndexedDB sólo en cliente y no se ejecute en SSR.
 */

import { useEffect } from "react";

export default function DrainerBoot() {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const mod = await import("@/lib/offline/drainer");
        if (cancelled) return;
        mod.startDrainer();
        // Subida-al-sync de las fotos del form pre-cosecha (paralelo al drainer,
        // mismos disparadores). No bloquea la captura offline.
        const foto = await import("@/lib/offline/foto-uploader");
        if (cancelled) return;
        foto.startFotoUploader();
      } catch {
        /* sin IndexedDB en este entorno — ok */
      }
    })();

    // GAP-K: precargar la caché del módulo de campo desde CUALQUIER parte de la
    // app cuando hay señal (los warms son TTL-guardados, ~1x/día). Así /campo
    // funciona en su 1ª visita OFFLINE aunque nunca se haya abierto online. Con
    // retardo para no competir con la carga inicial de la página.
    const warmTimer = setTimeout(async () => {
      try {
        const { isOnline } = await import("@/lib/hooks/useNetworkStatus");
        if (cancelled || !isOnline()) return;
        const [territorial, siembra, prog] = await Promise.all([
          import("@/lib/offline/territorial-cache"),
          import("@/lib/offline/siembra-warm"),
          import("@/lib/offline/prog-aportes-warm"),
        ]);
        territorial.warmTerritorial().catch(() => {});
        siembra.warmSiembraData().catch(() => {});
        prog.warmProgAportes().catch(() => {});
      } catch {
        /* best-effort */
      }
    }, 8000);

    return () => {
      cancelled = true;
      clearTimeout(warmTimer);
    };
  }, []);
  return null;
}
